import React from "react";
import cn from "classnames";

import { IllustrationProps } from "./Illustration.props";
import illustrationsNames from "./Illustration.Components";

import styles from "./Illustration.module.scss";

const Illustration: React.FC<IllustrationProps> = (props: IllustrationProps): JSX.Element | null => {
  const { id, name, className, testId } = props;
  const illustrationClass = cn(styles["illustration"], className);

  if (typeof illustrationsNames[name] !== "undefined") {
    return React.createElement(
      illustrationsNames[name],
      {
        id: id,
        className: illustrationClass,
        "data-testid": testId ? `test__${testId}-illustration` : undefined,
      },
      null,
    );
  } else {
    return null;
  }
};

export default Illustration;
